var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"animated fadeInRight","leave-active-class":"animated fadeOutLeft"}},[(_vm.active)?_c('div',{staticClass:"exercise-modal"},[_c('div',{staticClass:"actions w-100 h-total"},[_c('img',{attrs:{"width":"30%","src":require("../../../assets/images/characters/charlie/charlie_face.png")}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }